module.exports = __webpack_public_path__ + "static/aesthetik-logo-02-40b352c20260a49a58b5ff2ca42e7a41.png";